import {
    DIC
} from '@/const/dic'
// import {
//     validateChinese
// } from '@/util/validate'
// import {
//     formatterTime
// } from '@/util/util'



export const paymentDetailOption = {
    align: "center",
    menuAlign: "center",
    headerAlign: "center",
    border: true,
    expand: false,
    stripe: false,
    showHeader: true,
    // align: 'center',
    index: false,
    selection: true,
    menu: true,
    page: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    //viewBtn: true,
    columnBtn: false,
    menuWidth: '200',
    labelWidth: '150',
    defaultSort: {
        prop: 'createTime',
        order: 'descending'
    },
    column: [{
            label: "应付款编号",
            prop: "dueNumber",
            search: true,
            type: 'input'
        },
        {
            label: "退货订单编号",
            prop: "exitNumber",
            type: "input",
        },
        {
            label: "账号",
            prop: "account",
            type: 'input',
        },
        {
            label: "店铺名称",
            prop: "shopName",
            type: "input",
        },

        {
            label: "退货时间",
            prop: "exitTime",
            type: "datetime",
            // sortable: true,
            valueFormat: "timestamp",
            format: "yyyy-MM-dd HH:mm:ss",
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "退货时间",
            prop: "startDate_endDate",
            type: "datetimerange",
            valueFormat: "timestamp",
            span: 24,
            clearable: true,
            hide: true,
            search: true,
            addVisdiplay: false,
            editVisdiplay: false,
            formatter: function (row, value, label, column) {
                return formatterTime(row.startTime) + '至' + formatterTime(row.endTime)
            }
        },
        {
            label: "应付款状态",
            prop: "status",
            type: "select",
            search: true,
            dicData: DIC.STOCK_PAYMENT_STATUS
        },
        {
            label: "支付时间",
            prop: "payTime",
            type: "datetime",
            // sortable: true,
            valueFormat: "timestamp",
            format: "yyyy-MM-dd HH:mm:ss",
            addVisdiplay: false,
            editVisdiplay: false
        },

        {
            label: "应付款总计金额",
            prop: "totalMoney",
            type: "input",
        },
        {
            label: "支付时间区间",
            prop: "payTimeInterval",
            type: "datetimerange",
            sortable: true,
            valueFormat: "timestamp",
            format: "yyyy-MM-dd HH:mm:ss",
            // search: true,
            hide: true,
            addVisdiplay: false,
            editVisdiplay: false
        },

    ]
};